import React from 'react';
import Navbar from '../../components/navbar';
import Content1 from '../../components/content1';
import Content2 from '../../components/content2';
import Footer from '../../components/footer';
import Profile from '../../components/profile';
import Notification from '../../components/Notification';
import Trolly from '../../components/Trolly';

export default function Home() {
  const [user, setUser] = React.useState({});

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR"
    }).format(number);
  }

  const eWallet =
    <div className=' iklan2 px-4 py-3 col-4  pay'>
      <h1 className='payWallet'  data-bs-dismiss="modal" aria-label="Close">W-ShopPay</h1>
      <div className=' d-flex my-1 mt-4'>
        <img src='/img/iconMoney.png' className='payImg' alt='' />
        <p style={{ fontSize: '25px' }} className=' mt-2'>{rupiah(user.saldo)}</p>
      </div>
      <a href='/isiSaldo' className=' d-flex text-decoration-none payBg justify-content-center p-1'>
        <p className='isiSaldo p-1 pt-2'>Isi Saldo</p>
        <img src='/img/iconScan.png' className='payImg' alt='' />
      </a>
    </div>;
  return (
    <>
      <Navbar userData={setUser} logReg={<Profile userData={user}  />} notification={<Notification/>} trolly={<Trolly/>}/>   
      <Content1 item2={eWallet} />
      <Content2></Content2>
      <Footer />
    </>
  );
}
